module.exports = __webpack_public_path__ + "img/23_72.76073cde.png";